import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';

interface Promo extends ListRow {
  id: number;
  title?: string;
  description?: string;
  create_time?: number;
  manager_id?: number;
}

const config: ListPageConfig<Promo> = {
  queryKey: 'marketing-promo',
  title: 'Промо',
  boxTitle: 'Список промо',
  errorText: 'Ошибка загрузки промо',
  fetchList: postListFetcher('/billing/billing-promo/index/'),
  rows: ['items'],
  sortStyle: 'signed',
  searchKeys: [{ value: 'title', label: 'Поиск по Заголовку' }],
  headerActions: (
    <Link to="/marketing/promo/create" className="btn btn-info pull-right">
      Создать
    </Link>
  ),
  columns: [
    { header: 'ID', sortField: 'id', render: (promo) => promo.id },
    { header: 'Заголовок', render: (promo) => promo.title || 'No title' },
    {
      header: 'Дата, время создания',
      sortField: 'expired_time',
      render: (promo) => formatUnixDateTime(promo.create_time) || 'No create time',
    },
    { header: 'Описание', render: (promo) => promo.description || 'No description' },
    { header: 'ID менеджера', render: (promo) => promo.manager_id || 'No manager_id' },
    {
      header: 'Edit',
      render: (promo) => (
        <Link to={`/marketing/promo/edit/${promo.id}`} className="btn btn-success btn-sm">
          Edit
        </Link>
      ),
    },
  ],
};

export const PromoPage = () => <GenericListPage config={config} />;
